.bar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.searchWrap {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: var(--white);
  border: var(--b);
  border-radius: var(--r-md);
}

.searchIcon { color: var(--mute); flex-shrink: 0; }

.input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-family: var(--sans);
  font-weight: 600;
  font-size: 14px;
  color: var(--ink);
}

.input::placeholder { color: var(--mute); }

.filtriBtn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border: var(--b);
  border-radius: var(--r-md);
  background: var(--white);
  font-family: var(--sans);
  font-weight: 800;
  font-size: 12px;
  color: var(--ink);
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.filtriBtn:hover { background: var(--off); }

.count {
  font-family: var(--mono);
  font-size: 11px;
  font-weight: 700;
  color: var(--mute);
  letter-spacing: 0.6px;
  white-space: nowrap;
}
